// extracted by mini-css-extract-plugin
export default {"routineblock":"mP","container":"nP","carousel":"oP","routine":"pP","heading":"qP","routinelist":"rP","routineitem":"sP","routineimg":"tP","routinedesc":"uP","routinename":"vP","routinetext":"wP","carouselwrap":"xP"};
    if(module.hot) {
      // 1713361652931
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  